
/**
 * Created by Mateusz Lipowski on 08.11.2016.
 */

namespace Action.ContextMenu {
    export class ClientDevices extends Action.UserActionBase {
        public constructor(event: Action.UserActionEvent) {
            super(event);
        }

        public execute(): void {
            let clientNode: Entity.Map.Marker.Node.ClientNode = this.event.target as Entity.Map.Marker.Node.ClientNode;
            let clientDevicesDevicesWindow: Entity.View.Window.DevicesWindow = this.app.service.windowContainer.createWindow(Control.WindowClass.DEVICES_WINDOW) as Entity.View.Window.DevicesWindow;
            clientDevicesDevicesWindow.showForNode(clientNode, true);
        }
    }
}
